import { render, staticRenderFns } from "./ReceiveAdj.vue?vue&type=template&id=0a62ec8e&scoped=true"
import script from "./ReceiveAdj.vue?vue&type=script&lang=js"
export * from "./ReceiveAdj.vue?vue&type=script&lang=js"
import style0 from "./ReceiveAdj.vue?vue&type=style&index=0&id=0a62ec8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a62ec8e",
  null
  
)

export default component.exports